import { Fragment, ReactNode } from "react";

const BOLD_TOKEN = /(\*[^*\n]+\*)/g;

export type WhatsAppTextSegment = {
  bold: boolean;
  value: string;
};

export function normalizeWhatsAppNewlines(text: string): string {
  return text.replace(/\r\n/g, "\n");
}

export function splitWhatsAppSegments(text: string): WhatsAppTextSegment[] {
  const normalized = normalizeWhatsAppNewlines(text);
  return normalized.split(BOLD_TOKEN).map((part) => {
    const boldMatch = part.match(/^\*([^*]+)\*$/);
    if (boldMatch) {
      return { bold: true, value: boldMatch[1] };
    }
    return { bold: false, value: part };
  });
}

export function renderWhatsAppText(text: string): ReactNode {
  return splitWhatsAppSegments(text).map((segment, index) => {
    if (segment.bold) {
      return <strong key={index}>{segment.value}</strong>;
    }
    return <Fragment key={index}>{segment.value}</Fragment>;
  });
}
